// Mapeia pathname (HashRouter) -> {modulo, funcionalidade} para a telemetria
// de navegacao em usage_events. Ordenado do prefixo mais especifico pro mais
// generico -- checagem e sempre "startsWith", entao a ordem importa (ex.:
// "/tarefas/solicitacoes" tem que ser checado antes de "/tarefas").
//
// Módulos ainda sem nenhuma regra de funcionalidade aqui (Academy, Vick) não
// têm telas internas reais pra separar -- ver moduloTemFuncionalidade, que a
// UI usa pra só convidar o clique de drill-down onde existe o próximo nível.
// Nova rota: adicione a entrada aqui (mais específica antes da genérica do
// módulo). Nova ação de negócio: ver FUNCIONALIDADES_COM_ACAO abaixo.

export interface RotaResolvida {
  modulo: string;
  funcionalidade: string | null;
}

interface Regra {
  prefixo: string;
  modulo: string;
  funcionalidade?: string;
}

const REGRAS: Regra[] = [
  { prefixo: '/crm/prospeccao', modulo: 'crm', funcionalidade: 'prospeccao' },
  { prefixo: '/crm/rotas', modulo: 'crm', funcionalidade: 'rotas' },
  { prefixo: '/crm/mapa', modulo: 'crm', funcionalidade: 'mapa' },
  { prefixo: '/crm/pos-venda', modulo: 'crm', funcionalidade: 'pos_venda' },
  { prefixo: '/crm/analytics', modulo: 'crm', funcionalidade: 'analytics' },
  { prefixo: '/crm/minha-comissao', modulo: 'crm', funcionalidade: 'minha_comissao' },
  { prefixo: '/crm', modulo: 'crm', funcionalidade: 'funil' }, // index do CRM = Funil/Kanban
  { prefixo: '/tarefas/solicitacoes', modulo: 'tarefas', funcionalidade: 'solicitacoes' },
  { prefixo: '/tarefas', modulo: 'tarefas' },
  { prefixo: '/financeiro/painel-executivo', modulo: 'financeiro', funcionalidade: 'painel_executivo' },
  { prefixo: '/financeiro/ucs', modulo: 'financeiro', funcionalidade: 'ucs' },
  { prefixo: '/financeiro/faturas', modulo: 'financeiro', funcionalidade: 'faturas' },
  { prefixo: '/financeiro/parcelamentos', modulo: 'financeiro', funcionalidade: 'parcelamentos' },
  { prefixo: '/financeiro/boletos', modulo: 'financeiro', funcionalidade: 'boletos' },
  { prefixo: '/financeiro/folha-pagamento', modulo: 'financeiro', funcionalidade: 'folha_pagamento' },
  { prefixo: '/financeiro/lembretes-cobranca', modulo: 'financeiro', funcionalidade: 'lembretes_cobranca' },
  { prefixo: '/financeiro/cancelamentos', modulo: 'financeiro', funcionalidade: 'cancelamentos' },
  { prefixo: '/financeiro/adesao-boleto-unico', modulo: 'financeiro', funcionalidade: 'adesao_boleto_unico' },
  { prefixo: '/financeiro/auditoria-pagamentos', modulo: 'financeiro', funcionalidade: 'auditoria_pagamentos' },
  { prefixo: '/financeiro/repasse-equatorial-manual', modulo: 'financeiro', funcionalidade: 'repasse_equatorial' },
  { prefixo: '/financeiro/previsao-recebiveis', modulo: 'financeiro', funcionalidade: 'previsao_recebiveis' },
  { prefixo: '/financeiro/conferencia-faturamento', modulo: 'financeiro', funcionalidade: 'conferencia_faturamento' },
  { prefixo: '/financeiro', modulo: 'financeiro', funcionalidade: 'dashboard' }, // index do Financeiro = Dashboard
  { prefixo: '/gestao/extracao/historico', modulo: 'gestao', funcionalidade: 'extracao_historico' },
  { prefixo: '/gestao/extracao', modulo: 'gestao', funcionalidade: 'extracao' },
  { prefixo: '/gestao/rateio/dashboard', modulo: 'gestao', funcionalidade: 'rateio_dashboard' },
  { prefixo: '/gestao/rateio/ancora', modulo: 'gestao', funcionalidade: 'rateio_ancora' },
  { prefixo: '/gestao/rateio/conciliacao', modulo: 'gestao', funcionalidade: 'rateio_conciliacao' },
  { prefixo: '/gestao/rateio/distribuidoras', modulo: 'gestao', funcionalidade: 'rateio_distribuidoras' },
  { prefixo: '/gestao/rateio-antigo', modulo: 'gestao', funcionalidade: 'rateio_antigo' }, // checar ANTES do "/gestao/rateio" bare -- senão cai no simulador por engano
  { prefixo: '/gestao/rateio-saldos', modulo: 'gestao', funcionalidade: 'rateio_saldos' }, // idem: antes do "/gestao/rateio" bare
  { prefixo: '/gestao/rateio', modulo: 'gestao', funcionalidade: 'rateio_simulador' }, // index do Rateio novo
  { prefixo: '/gestao/lemit', modulo: 'gestao', funcionalidade: 'lemit' },
  { prefixo: '/gestao', modulo: 'gestao', funcionalidade: 'dashboard' }, // index do modulo = GestaoCard
  { prefixo: '/geradoras', modulo: 'geradoras' },
  { prefixo: '/marketing/campanhas', modulo: 'marketing', funcionalidade: 'campanhas' },
  { prefixo: '/marketing/criativos', modulo: 'marketing', funcionalidade: 'criativos' },
  { prefixo: '/marketing', modulo: 'marketing' }, // index so redireciona (Navigate) -- nunca fica settled aqui
  { prefixo: '/academy', modulo: 'academy' },
  { prefixo: '/vick', modulo: 'vick' },
  { prefixo: '/ferramentas/dividir-pdf', modulo: 'ferramentas', funcionalidade: 'dividir_pdf' },
  { prefixo: '/ferramentas/consulta-dados', modulo: 'ferramentas', funcionalidade: 'consulta_dados' },
  { prefixo: '/ferramentas', modulo: 'ferramentas', funcionalidade: 'inicio' }, // index = grade de cartões
  { prefixo: '/config/profile', modulo: 'config', funcionalidade: 'perfil' },
  { prefixo: '/config/dados-bancarios', modulo: 'config', funcionalidade: 'dados_bancarios' },
  { prefixo: '/config/financeiro', modulo: 'config', funcionalidade: 'meu_dinheiro' }, // "Meu Dinheiro" do parceiro -- nao confundir com o modulo Financeiro
  { prefixo: '/config/notifications', modulo: 'config', funcionalidade: 'notificacoes' },
  { prefixo: '/config/users', modulo: 'config', funcionalidade: 'usuarios' },
  { prefixo: '/config/equipe-parceiros', modulo: 'config', funcionalidade: 'equipe_parceiros' },
  { prefixo: '/config/pipelines', modulo: 'config', funcionalidade: 'pipelines' },
  { prefixo: '/config/slas', modulo: 'config', funcionalidade: 'slas' },
  { prefixo: '/config/escalas', modulo: 'config', funcionalidade: 'escalas' },
  { prefixo: '/config/avisos', modulo: 'config', funcionalidade: 'avisos' },
  { prefixo: '/config/logs', modulo: 'config', funcionalidade: 'logs' }, // cobre as abas Logs e Uso -- nao diferenciam URL
  { prefixo: '/config/apis', modulo: 'config', funcionalidade: 'apis' },
  { prefixo: '/config/termo-signatarios', modulo: 'config', funcionalidade: 'termo_signatarios' },
  { prefixo: '/config/empresas-parceiras', modulo: 'config', funcionalidade: 'empresas_parceiras' },
  { prefixo: '/config/conta-asaas-vigor', modulo: 'config', funcionalidade: 'conta_asaas_vigor' },
  { prefixo: '/config', modulo: 'config', funcionalidade: 'overview' }, // index = ConfigOverview
  { prefixo: '/dashboard', modulo: 'dashboard' },
  { prefixo: '/', modulo: 'dashboard' }, // raiz exata = DashboardHome
];

export function resolverModuloDaRota(pathname: string): RotaResolvida | null {
  for (const regra of REGRAS) {
    const bate = regra.prefixo === '/' ? pathname === '/' : pathname.startsWith(regra.prefixo);
    if (bate) {
      return { modulo: regra.modulo, funcionalidade: regra.funcionalidade ?? null };
    }
  }
  return null;
}

// Funcionalidades com pelo menos uma ação instrumentada via logUsageEvent --
// espelha, em telemetria de uso, os mesmos pontos que já viram logAction (o
// audit trail de Logs). Atualizar junto de cada novo logUsageEvent({ acao }).
const FUNCIONALIDADES_COM_ACAO = new Set([
  'crm/funil',
  'crm/inadimplencia',
  'crm/rotas',
  'crm/prospeccao',
  'crm/analytics',
  'crm/mapa',
  'financeiro/faturas',
  'financeiro/ucs',
  'financeiro/parcelamentos',
  'financeiro/boletos',
  'financeiro/auditoria_pagamentos',
  'financeiro/adesao_boleto_unico',
  'financeiro/cancelamentos',
  'financeiro/lembretes_cobranca',
  'financeiro/folha_pagamento',
  'financeiro/repasse_equatorial',
  'tarefas/solicitacoes',
  'config/usuarios',
  'config/perfil',
  'config/empresas_parceiras',
  'config/escalas',
  'config/avisos',
  'config/apis',
  'config/termo_signatarios',
  'config/notificacoes',
  'config/slas',
  'config/pipelines',
  'config/conta_asaas_vigor',
  'config/dados_bancarios',
  'config/logs',
  'gestao/dashboard',
  'gestao/rateio_antigo',
  'gestao/rateio_simulador',
  'gestao/rateio_distribuidoras',
  'gestao/rateio_dashboard',
  'gestao/rateio_conciliacao',
  'ferramentas/dividir_pdf',
  'ferramentas/consulta_dados',
]);

// Módulos cuja funcionalidade é sinalizada por um logUsageEvent manual, fora
// de resolverModuloDaRota -- caso do Geradoras, que troca de aba (Painel /
// Análise) via history.replaceState direto, sem passar pelo HashRouter (ver
// GeradorasView.tsx), então location.pathname nunca muda e a regra por
// prefixo não teria como enxergar a aba.
const MODULOS_COM_FUNCIONALIDADE_MANUAL = new Set(['geradoras']);

// Usados pela tela de telemetria (UsoView) pra só convidar o clique de
// drill-down onde realmente existe o próximo nível de detalhe -- clicar num
// módulo/funcionalidade sem instrumentação mais fina sempre resultaria em
// "sem dados", mesmo com uso real registrado no nível atual.
export function moduloTemFuncionalidade(modulo: string): boolean {
  return MODULOS_COM_FUNCIONALIDADE_MANUAL.has(modulo) || REGRAS.some(r => r.modulo === modulo && r.funcionalidade !== undefined);
}

export function funcionalidadeTemAcao(modulo: string, funcionalidade: string): boolean {
  return FUNCIONALIDADES_COM_ACAO.has(`${modulo}/${funcionalidade}`);
}
